var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerMultipleChoiceOptionGridCell } from './AbfragerMultipleChoiceOptionGridCell';
import { AbfragerMultipleChoiceOptionRow } from './AbfragerMultipleChoiceOptionRow';
import { QuestionCorrectWrong } from '../../../../../questiontype/CorrectWrong/QuestionCorrectWrong';
import { AbfragerMultipleChoiceOptionButton } from './AbfragerMultipleChoiceOptionButton';
import { QuestionAssociate } from '../../../../../questiontype/Associate/QuestionAssociate';
let AbfragerMultipleChoiceLikeOption = class AbfragerMultipleChoiceLikeOption extends React.PureComponent {
    render() {
        const { option, indexInLayout } = this.props;
        const question = option.question;
        let AbfragerOptionImpl = AbfragerMultipleChoiceOptionRow;
        if (question instanceof QuestionCorrectWrong) {
            AbfragerOptionImpl = AbfragerMultipleChoiceOptionButton;
        }
        if (question instanceof QuestionAssociate || question.layoutName.includes('Grid')) {
            AbfragerOptionImpl = AbfragerMultipleChoiceOptionGridCell;
        }
        return React.createElement(AbfragerOptionImpl, { option: option, indexInLayout: indexInLayout });
    }
};
AbfragerMultipleChoiceLikeOption = __decorate([
    observer
], AbfragerMultipleChoiceLikeOption);
export { AbfragerMultipleChoiceLikeOption };
